module.exports = __webpack_public_path__ + "static/media/partner_logo.4c544fd5.png";